import {
  SUBMIT_PLAYER_PURCHASE,
  SUBMIT_PLAYER_PURCHASE_SUCCESS,
  SUBMIT_PLAYER_PURCHASE_ERROR,
  SUBMIT_PLAYER_PURCHASE_STRIPE,
  SUBMIT_PLAYER_PURCHASE_STRIPE_SUCCESS,
  SUBMIT_PLAYER_PURCHASE_STRIPE_ERROR
} from "./constants";

export function submitPlayerPurchase(params) {
  return {
    type: SUBMIT_PLAYER_PURCHASE,
    params
  };
}

export function submitPlayerPurchaseError(err) {
  return {
    type: SUBMIT_PLAYER_PURCHASE_ERROR,
    err
  };
}
export function submitPlayerPurchaseDone(payload) {
  return {
    type: SUBMIT_PLAYER_PURCHASE_SUCCESS,
    payload
  };
}

export function submitPlayerPurchaseStripe(params) {
  return {
    type: SUBMIT_PLAYER_PURCHASE_STRIPE,
    params
  };
}

export function submitPlayerPurchaseStripeError(err) {
  return {
    type: SUBMIT_PLAYER_PURCHASE_STRIPE_ERROR,
    err
  };
}
export function submitPlayerPurchaseStripeDone(payload) {
  return {
    type: SUBMIT_PLAYER_PURCHASE_STRIPE_SUCCESS,
    payload
  };
}
